module.exports = __webpack_public_path__ + "img/logo-vue.521bba0c.svg";